<div class="p-card">
    <div class="p-card-title p-mb-2 p-mt-4" style="font-weight: bold">
        {{ 'home.onboardingProfile.yourSkillsTitle' | translate }}
    </div>
    <div class="p-card-subtitle p-mb-3">
        {{ 'home.onboardingProfile.yourSkillsSubtitle1' | translate }}
        <span style="font-weight: bold">{{ 'home.onboardingProfile.yourSkillsSubtitle2' | translate }}</span>
    </div>

    <app-user-skills-form [user]="currentUser"></app-user-skills-form>
</div>
